import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export function showError(text: string) {
  Toastify({
    text,
    duration: 3000,
    newWindow: true,
    close: false,
    gravity: "top",
    position: "center",
    stopOnFocus: true,
    style: {
      background: "linear-gradient(to right, #aa323f, #F34852)",
    },
  }).showToast();
}

export function showWarning(text: string) {
  Toastify({
    text,
    duration: 1500,
    newWindow: true,
    close: false,
    gravity: "top",
    position: "center",
    stopOnFocus: true,
    style: {
      background: "linear-gradient(to right, #F5aa0D, #F5BD0D)",
    },
  }).showToast();
}

export function showSuccess(text: string) {
  Toastify({
    text,
    duration: 1500,
    newWindow: true,
    close: false,
    gravity: "top",
    position: "center",
    stopOnFocus: true,
    style: {
      background: "linear-gradient(to right, #168549, #24DE7A)",
    },
  }).showToast();
}
